module.exports = __webpack_public_path__ + "img/up-right.22c25f9b.svg";